import { render } from "./KeyframeList.vue?vue&type=template&id=456474e6"
import script from "./KeyframeList.vue?vue&type=script&lang=ts"
export * from "./KeyframeList.vue?vue&type=script&lang=ts"

import "./KeyframeList.vue?vue&type=style&index=0&id=456474e6&lang=scss"
script.render = render

export default script